module.exports = __webpack_public_path__ + "static/media/log2.00b7b28a.jpg";